import type { PartnerInterventionStatus } from '@bcl/shared';

export const interventionStatusBadge: Record<
  PartnerInterventionStatus,
  { label: string; cls: string }
> = {
  assignee: { label: 'Assignée', cls: 'bg-blue-100 text-blue-800' },
  rapport_depose: { label: 'Rapport déposé', cls: 'bg-amber-100 text-amber-800' },
  validee: { label: 'Validée', cls: 'bg-green-100 text-green-800' },
  rejetee: { label: 'Rejetée', cls: 'bg-red-100 text-red-800' },
  litige: { label: 'Litige', cls: 'bg-orange-100 text-orange-800' },
};
